import React from 'react';
import closeIcon from "../../../assets/images/close.png";


interface Props {
    handler: () => void
}

const CloseIconComponent: React.FC<Props> = ({ handler }) => {
    return (
        <div className='close-icon pointer'
             onClick={ (e: React.MouseEvent) => {
                 e.preventDefault();
                 e.stopPropagation();
                 handler()
             }}>
            <img src={ closeIcon }
                 alt="close"
                 width='8px'
            />
        </div>
    )
};

export default CloseIconComponent